import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '../main/main.component';
import { AboutUsComponent } from './about-us.component';

const routes: Routes = [
  { 
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'nosotros',
        component: AboutUsComponent
      }
    ]
  },
];

export const AboutUsRoutes = RouterModule.forChild(routes);
